import cssVars from "css-vars-ponyfill";

export function watermark(selector) {
  // Check if the provided selector has any matching elements
  if (jQuery(selector).length === 0) {
    return;
  }

  // Select all watermark images within the specified selector
  const watermarks = jQuery(`${selector} .watermark img`);

  // Function to set the appropriate watermark based on the viewport size
  function updateWatermark(item) {
    const watermarkmobile = item.getAttribute("data-watermarkmobile");
    const watermarkdesktop = item.getAttribute("data-watermarkdesktop");

    // Only proceed if the mobile watermark exists
    if (watermarkmobile) {
      // Determine the current viewport size
      const isMobile = window.matchMedia("(max-width: 991px)").matches;

      // Set the watermark based on the viewport size
      if (isMobile && watermarkmobile) {
        item.setAttribute("src", watermarkmobile);
        item.setAttribute("data-src", watermarkmobile);
      } else if (watermarkdesktop) {
        item.setAttribute("src", watermarkdesktop);
        item.setAttribute("data-src", watermarkdesktop);
      }
    }
  }

  // Update watermarks on load and resize events
  jQuery(window).on("load resize", function () {
    watermarks.each(function (i, item) {
      updateWatermark(item);
    });
  });

  // Initial call to set watermarks correctly on page load
  watermarks.each(function (i, item) {
    updateWatermark(item);
  });
}

export default watermark;

// export function footer__watermark() {

// 	if (jQuery(".footer").length < 0) {
// 		return;
//   }

//   const watermark = jQuery(".footer .watermark img");

//   jQuery(watermark).each(function (i, item) {
//     var watermarkmobile = item.getAttribute("data-watermarkmobile");
//     var watermarkdesktop = item.getAttribute("data-watermarkdesktop");

//     // If has watermark mobile
//     if(item.hasAttribute("data-watermarkmobile")) {
//       jQuery(window).on("load resize", function () {

//         if ((typeof watermarkmobile !== 'undefined' && watermarkmobile !== false) && (typeof watermarkmobile !== 'undefined' && watermarkmobile !== false) || (typeof watermarkmobile !== 'undefined' && watermarkmobile !== false)) {
//           // Mobile (Tablet down)
//           if (window.matchMedia("(max-width: 991px)").matches) {
//             function setMobileWatermark() {
//               item.setAttribute("data-src", watermarkmobile);
//               item.setAttribute("src", watermarkmobile);
//             }
//             setMobileWatermark();
//           }

//           // Desktop (Tablet up)
//           if (window.matchMedia("(min-width: 991px)").matches) {
//             function setDesktopWatermark() {
//               item.setAttribute("data-src", watermarkdesktop);
//               item.setAttribute("src", watermarkdesktop);
//             }
//             setDesktopWatermark();
//           }
//         } else {
//           return;
//         }

//       });

//     } else {
//       return;
//     }

//   });

// }

// export default footer__watermark;
